module.exports = __webpack_public_path__ + "static/media/Sigma.7112e2ee.mp4";